import {
  ClientGeoAreaProfileFactTypeEnum,
  type ClientGeoAreaProfile
} from '@DigitaleDoerfer/digitale-doerfer-api';
import type { FC } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { FACT_TYPE_ICONS } from '@/features/geo-area/constants/fact';
import { ListItem } from '@/features/list/components/ListItem';
import { ListSection } from '@/features/list/components/ListSection';
import { ImageCarousel } from '@/features/media/components/image/ImageCarousel';
import { hasItems } from '@/shared/utils/array';
import { handleOpenUrl } from '@/shared/utils/url';

const styles = StyleSheet.create({ container: { gap: 24 } });

type Props = { geoAreaProfile: ClientGeoAreaProfile };

export const GeoAreaDetails: FC<Props> = ({ geoAreaProfile }) => (
  <View style={styles.container}>
    <Text ellipsizeMode="tail" variant="bodyLarge">
      {geoAreaProfile.description}
    </Text>

    {hasItems(geoAreaProfile.images) && (
      <ImageCarousel mediaItems={geoAreaProfile.images} />
    )}
    {hasItems(geoAreaProfile.facts) && (
      <ListSection>
        {geoAreaProfile.facts.map(({ name, type, value }) => (
          <ListItem
            key={name}
            iconSize={24}
            icon={FACT_TYPE_ICONS[type]}
            title={name}
            badge={value}
            hideRightArrow
            onPress={
              type === ClientGeoAreaProfileFactTypeEnum.Url
                ? () => {
                    handleOpenUrl(value);
                  }
                : undefined
            }
          />
        ))}
      </ListSection>
    )}
  </View>
);
